export const COMMUNITY = "community";
export const PROPERTIES = "properties";
export const VIEW_PROPERTY = "view_property";
export const USERS = "users";
export const COMM_USERS = "community_users";
export const VIEW_USERS = "view_users";
